import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import Layout from '../../components/Layout';

const AdminCupones: React.FC = () => {
  return (
    <Layout>
      <Box>
        <Typography variant="h4" gutterBottom>
          Gestión de Cupones
        </Typography>
        
        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Cupones - En Desarrollo
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Esta sección permitirá crear, editar y gestionar cupones individuales y masivos.
            Funcionalidades incluidas:
          </Typography>
          <Box component="ul" sx={{ mt: 2 }}>
            <li>Crear cupones individuales para usuarios específicos de WordPress</li>
            <li>Generar cupones masivos</li>
            <li>Configurar descuentos por porcentaje o monto fijo</li>
            <li>Establecer límites de uso y fechas de expiración</li>
            <li>Activar/desactivar cupones</li>
            <li>Generar códigos QR</li>
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default AdminCupones;
